export function paramToBoolean(param: string | string[] | undefined) {
  const value = ((param as string | undefined) || '').toLowerCase();
  return ['true', 'yes', '1'].includes(value);
}
